import React, { useState, useRef, useCallback } from "react";
import { api } from "../api/api";
import "./EditMemberModal.css";
// Le classi CONDIVISE che questa pagina riusa invece di ridichiararle:
// pastiglia categoria §2 (.qpsc-pill) e pulsanti §5.1/§5.3 (.qpsc-tool-btn,
// .qpsc-ghost-btn). Il foglio contiene solo selettori di classe con prefisso
// `qpsc-`: importarlo non tocca nessun'altra pagina. Stessa via di
// MemberProfileModal.jsx — e le classi NON si ridefiniscono nel foglio
// proprio, che è l'incidente chiuso da 5d137b6.
import "./AdminTools.css";
import Webcam from "react-webcam";
import { useAuth } from "../context/AuthContext";
import { ROLE_LABELS, normalizeRole } from "../auth/access";
import { hasRole } from "../utils/roleUtils";
import AuthAvatar from "./AuthAvatar";
import avatarPlaceholder from "../assets/avatar-placeholder.png";
import { PastigliaCategoriaSeNota } from "./PastigliaCategoria";
import { categoriaAnagrafica } from "../utils/categoria";
// L'età compiuta con la STESSA regola di calendario del server
// (`isMinorDaDob`): il club vive a Perth e il compleanno non ancora arrivato
// vale un anno in meno. Le stesse due funzioni di View Profile — riusarle,
// invece di riscrivere il conto, è ciò che impedisce alle due rese di
// divergere nel giorno del compleanno.
// ⚠️ `GENERI` (fase 3) è il VOCABOLARIO CANONICO del genere — valore «M»/«F»,
// etichetta per esteso — cioè la stessa costante che usano Enrol, EnrolFamily e
// HomeIncomplete, e la sola forma che le rotte nuove del server accettano
// (server.js). Si importa invece di riscrivere le opzioni a mano: un
// secondo vocabolario dichiarato qui divergerebbe dal primo al primo ritocco
// (CLAUDE.md: sede unica).
import { etaCompiuta, oggiAPerth, GENERI } from "../utils/enrolDati";

const stateOptions = [
  "New South Wales", "Queensland", "South Australia", "Tasmania",
  "Victoria", "Western Australia", "Australian Capital Territory", "Northern Territory"
];

// La domanda sulla disabilità ha TRE risposte — sì, no, non dichiarato — e il
// documento le porta come true / false / null. Nella tendina diventano tre
// valori di testo, perché un <select> non conosce i booleani.
//
// ⚠️ È la STESSA regola di `disabilitaDalDocumento` in HomeIncomplete.jsx,
// da cui è ricalcata riga per riga: la finestra della persona e
// quella dell'amministratore devono leggere lo stesso campo allo stesso modo.
// In particolare il `null` NON diventa «no»: «non dichiarato» resta tale, e
// solo una scelta esplicita lo cambia.
const disabilitaDalDocumento = (valore) => {
  if (valore === true) return "yes";
  if (valore === false) return "no";
  return "";
};

// ======================================================================
// FASE 3 — I DUE LETTORI DEL DOCUMENTO (genere e data di nascita).
// Servono a NON far scomparire in silenzio un dato che c'è: leggono ciò che
// sta agli atti e dicono se è utilizzabile, senza mai riscriverlo.
// ======================================================================

// IL GENERE COME STA NEL DOCUMENTO → «M», «F», oppure «» se non si riconosce.
//
// Nei dati convivono due grafie: «M»/«F» (le rotte d'iscrizione nuove, che non
// accettano altro — server.js) e «Male»/«Female» per esteso (le
// schede create a mano dalle finestre vecchie). La conversione è secca e
// case-insensitive, e vale SOLO dove la corrispondenza è certa.
//
// ⚠️ Tutto il resto — «Other», o qualunque altra cosa — torna «» e NON viene
// riscritto d'iniziativa: la stringa vuota qui significa «non so tradurlo»,
// non «cancellalo». Chi chiama distingue i due casi guardando il valore
// grezzo, e il valore grezzo resta agli atti finché un amministratore non
// sceglie consapevolmente (vedi l'avviso accanto al campo e l'omissione dal
// payload in handleSubmit).
const genereDalDocumento = (valore) => {
  const testo = String(valore === null || valore === undefined ? "" : valore)
    .trim()
    .toUpperCase();

  if (testo === "M" || testo === "MALE") return "M";
  if (testo === "F" || testo === "FEMALE") return "F";
  return "";
};

// LA DATA DI NASCITA È LEGGIBILE? Sì solo se supera IL CONTROLLO GIÀ ESISTENTE,
// quello di `etaCompiuta`: forma ISO `YYYY-MM-DD` più esistenza a calendario
// («2010-02-31» supera la forma e non il calendario). `etaCompiuta` torna null
// esattamente nei casi in cui il server risponderebbe 400 «Invalid dob»
// (`stesso criterio in forma più stretta: il client accetta solo YYYY-MM-DD; il server tollera anche mese/giorno a una cifra e un suffisso orario`, server.js), ed è per questo che si riusa lei
// invece di scrivere un secondo interprete di date nel frontend.
//
// ⚠️ Questo NON è un controllo di formato nuovo e non ne sostituisce alcuno:
// la validazione resta dov'era. Serve a decidere se MOSTRARE un avviso e se
// SPEDIRE il campo, niente di più.
const dataDiNascitaLeggibile = (valore) =>
  etaCompiuta(valore, oggiAPerth()) !== null;

// I ruoli che questa modale può ASSEGNARE, nella grafia del modello nuovo.
// Una lista SOLA: non dipende più da chi guarda, perché non c'è più nulla che
// un SUPERADMIN possa assegnare e un ADMIN no.
//
// ⚠️ La lista rispecchia `RUOLI_ASSEGNABILI_DA_ADMIN` sul backend (per NOME,
// non per riga: F1-F6 hanno spostato centinaia di righe di server.js). Non è
// una seconda autorità: decide il backend, qui si evita solo di OFFRIRE ciò
// che verrebbe rifiutato.
//
// ⚠️ LA VOCE «Admin» NON C'È PIÙ — fetta F7a, decisione D0. Era l'unica
// scalata di privilegio rimasta nell'app: la tendina la offriva a chi fosse
// SUPERADMIN, e il `PUT /users/:id` la scriveva. Ora il backend rifiuta con
// 403 qualunque scrittura di ADMIN o SUPERADMIN, per CHIUNQUE, e un
// amministratore si crea SOLO a mano in console. Togliere qui la voce non è
// cortesia grafica ridondante: è il non offrire una strada che porta a un
// muro.
//
// ⚠️ Nemmeno SUPERADMIN compare, e non è una dimenticanza: da questa rotta
// non è assegnabile da nessuno (l'unicità è garantita fuori dall'app).
//
// ⚠️ Il 403 «ruolo elevato sopravvivente nei contexts» (oggi: portare a
// PLAYER o PARENT chi ha un context COACH ATTIVO — quel context si toglie
// prima, dalla gestione dei contesti) ha da D-ADMIN2 (RD-157) il suo
// messaggio: vedi `eRifiutoDelRuoloNeiContesti` più sotto. Il limite di
// `api.js` citato qui fino a D-ADMIN2 non c'è più: `err.status` e `err.body`
// sono attaccati all'errore (`erroreDiRisposta`).
//
// ⚠️ Sono spariti «Manager», «Fan/Supporter» e «eSport Member»: il backend
// li rifiuta con 400 «Invalid role» (RUOLI_NOTI) e quel rifiuto fa cadere
// l'INTERA richiesta — nome, recapiti, indirizzo, data di nascita perduti per
// una voce di tendina che non doveva esistere.
//
// ⚠️ I `value` sono MAIUSCOLI perché è la grafia che finisce nei dati: il
// backend scrive sempre il valore normalizzato, mai quello grezzo.
// L'etichetta resta leggibile: il tutto-maiuscolo a schermo è vietato fuori
// dalle pastiglie (doc 07 §3.2).
const RUOLI_ASSEGNABILI_DA_ADMIN = [
  { value: "PLAYER", label: "Player" },
  { value: "PARENT", label: "Parent" },
  { value: "COACH", label: "Coach" }
];

// IL RIFIUTO DEL RUOLO CHE VIVE NEI CONTESTI (D-ADMIN2, RD-157). `PUT
// /users/:id` risponde 403 con un `detail` (in italiano) quando si cambia il
// ruolo di chi ha una tessera COACH o ADMIN ACTIVE: il ruolo si governa da
// Manage User Contexts. Gli altri 403 della rotta non portano `detail`, o ne
// portano uno diverso: il caso si riconosce da stato + `detail`, letto dal
// corpo come fa `messaggioDelServer` (utils/enrolDati.js). A schermo va una
// frase INGLESE scritta qui (§3.7), mai il `detail`. Non lancia mai: un corpo
// illeggibile vuol dire «non è questo caso», e resta il messaggio generico.
const MESSAGGIO_RUOLO_NEI_CONTESTI =
  "This person's role is managed in Manage User Contexts, not here. " +
  "Your details were not saved.";

function eRifiutoDelRuoloNeiContesti(err) {
  if (!err || err.status !== 403 || typeof err.body !== "string") return false;
  try {
    const corpo = JSON.parse(err.body);
    return (
      !!corpo &&
      typeof corpo.detail === "string" &&
      corpo.detail.includes("vive nei suoi contesti")
    );
  } catch {
    return false;
  }
}

// ------------------------------------------------------------------
// I TESTI DELL'ICONA «i» (SPEC §5, doc 07 §12.4).
//
// ⚠️ RIUSO LETTERALE da View Profile. Le quattro frasi `core`, `documents`,
// `wellbeing` e `wwc` sono copiate ALLA LETTERA dalla costante `DESCRIZIONI`
// di `MemberProfileModal.jsx`, che è la sorgente: la regola dice che il testo
// dice COSA È la sezione, mai l'elenco dei campi, e che è la specifica a
// doversi muovere verso quelle frasi, non il contrario. Se una di esse
// cambierà là, va riportata qui.
//
// ⚠️ Perché una COPIA e non un import: il componente-card e la costante di
// View Profile non sono esportati, e questo cantiere non ha titolo per
// modificare `MemberProfileModal.jsx` — è fuori dal suo perimetro. La sede
// unica si farà quando le due pagine condivideranno il componente (SPEC §5 lo
// prevede come «se»), non prima e non di nascosto.
//
// `primaryRole` è l'UNICA frase nuova, confermata dal committente il
// 22/8/2026: View Profile non ne ha una riusabile, perché la sua `roles`
// («What this member does at the club, across teams.») descrive i ruoli di
// squadra al plurale, non il ruolo primario che si sceglie qui.
// ------------------------------------------------------------------
const DESCRIZIONI = {
  core: "Who this member is and how to reach them.",
  documents: "Official documents proving the member's identity.",
  wellbeing: "What the club should know to support this member well.",
  primaryRole: "The member's primary role at the club.",
  wwc: "The clearance required to work with minors."
};

// ------------------------------------------------------------------
// SEZIONE-CARD (doc 07 §8 card, §12.3 gruppi, §12.4 icona «i»).
//
// ⚠️ L'icona e' un <button>, non uno <span> con onClick: e' un comando, deve
// essere raggiungibile da tastiera e annunciato da un lettore di schermo. Il
// pannello si apre AL TOCCO e si richiude al secondo tocco; l'oro dell'hover
// e' un extra da computer, schermato nel CSS (§11.3: mai un tooltip
// solo-hover). Stessa resa di View Profile, con classi proprie `qpsc-em-`.
// ------------------------------------------------------------------
const Sezione = ({ chiave, titolo, aperte, onApri, children }) => {
  const aperta = Boolean(aperte[chiave]);

  return (
    <section className="qpsc-em-card">
      <div className="qpsc-em-card__head">
        <h2 className="qpsc-em-card__title">{titolo}</h2>

        <button
          type="button"
          className={"qpsc-em-info" + (aperta ? " qpsc-em-info--open" : "")}
          aria-expanded={aperta}
          aria-controls={`qpsc-em-purpose-${chiave}`}
          aria-label={`What is “${titolo}”?`}
          onClick={() => onApri(chiave)}
        >
          <span className="qpsc-em-info__glyph" aria-hidden="true">i</span>
        </button>
      </div>

      {aperta && (
        <p className="qpsc-em-purpose" id={`qpsc-em-purpose-${chiave}`}>
          {DESCRIZIONI[chiave]}
        </p>
      )}

      {children}
    </section>
  );
};

// Un campo del modulo: etichetta SOPRA il campo (§8/§12.5). L'aiuto
// facoltativo (`aiuto`) e' il micro-testo sotto — una spiegazione, non un
// errore: vive in testo secondario, mai in rosso.
const Campo = ({ etichetta, htmlFor, aiuto, children }) => (
  <div className="qpsc-em-field">
    <label className="qpsc-em-label" htmlFor={htmlFor}>{etichetta}</label>
    {children}
    {aiuto && <p className="qpsc-em-hint">{aiuto}</p>}
  </div>
);

export default function EditMemberModal({ user, onClose, onSave }) {

  // Chi guarda si riconosce col GATE UNICO — `role` di primo livello PIÙ i
  // context ACTIVE — e non più con una regex sulla stringa `currentUserRole`,
  // cieca ai context: era lo stesso difetto chiuso in P3 sul pallino Alert.
  // Un ADMIN che porti il ruolo unicamente via context supera così l'ingresso
  // di questa modale e la sua tendina dei ruoli, come già poteva sul backend.
  //
  // ⚠️ EFFETTO NON PIÙ SOSPESO. L'unica porta di questa modale è il bottone
  // «Edit Member» di MemberProfileModal, che fino alla fase 1 del cantiere
  // View Profile restava gated sulla prop `currentUserRole` — residuo
  // dichiarato di P4. Caduta quella prop (tolta anche da questa firma: da
  // RL-7c-2 non decideva più nulla qui dentro, e l'ultima cosa che reggeva,
  // il `disabled` del campo Team, era morta col campo, fuori whitelist di
  // proposito — server.js), i due gate coincidono e chi entra qui è
  // esattamente chi vede il bottone.
  const { user: utenteCollegato, operatingSeason } = useAuth() || {};
  const isAdmin = hasRole(utenteCollegato, "ADMIN", "SUPERADMIN");

  // L'anno della pastiglia di categoria (D-ADMIN2, RD-157), come in
  // MemberProfileModal: con `useAuth() || {}` il valore può arrivare
  // `undefined`, e si riconduce all'unico nullo che il predicato conosce.
  const annoOperativo = operatingSeason == null ? null : operatingSeason;

  // ⚠️ QUI C'ERA `isSuperAdmin`, e con esso la scelta fra due liste di ruoli.
  // Sono caduti insieme alla voce «Admin» della tendina (F7a, decisione D0):
  // servivano SOLO a offrire quella voce a chi fosse SUPERADMIN, e senza di
  // essa la condizione restava orfana. La lista dei ruoli assegnabili è ora
  // una sola e uguale per tutti quelli che entrano qui. `isAdmin`, invece,
  // resta: regge il `disabled` della tendina.
  const ruoliAssegnabili = RUOLI_ASSEGNABILI_DA_ADMIN;

  const [form, setForm] = useState({
    ffaNumber: user.ffaNumber || '',
    firstName: user.firstName || '',
    middleName: user.middleName || '',
    lastName: user.lastName || '',
    dob: user.dob || '',
    // ⚠️ `cityOfBirth` NON C'È PIÙ, ed è la metà che conta della decisione D1
    // (SPEC §3): il payload viaggia per *rest* di `form`, quindi finché la
    // chiave restava qui continuava a essere SPEDITA anche senza campo a
    // schermo. Il valore eventualmente presente in Firestore non viene
    // toccato — il PUT non lo invia più, e il server conserva ciò che non
    // arriva: resta agli atti, semplicemente non è più né visibile né
    // correggibile dall'app.
    countryOfBirth: user.countryOfBirth || '',
    nationality: user.nationality || '',
    // FASE 3 — CONVERSIONE IN INGRESSO. La tendina lavora in «M»/«F»: un
    // documento che porti «Male» per esteso deve agganciare la voce giusta,
    // altrimenti resta su «Select» e l'obbligo costringe a riscegliere un dato
    // che c'era già. Un valore non traducibile diventa «» e fa comparire
    // l'avviso accanto al campo: non viene mai riscritto di nascosto.
    gender: genereDalDocumento(user.gender),
    email: user.email || '',
    phone: user.phone || '',
    role: user.role || '',
    street: user.street || '',
    suburb: user.suburb || '',
    state: user.state || '',
    postcode: user.postcode || '',

    idDocument: user.idDocument || null,
    otherDocument: user.otherDocument || null,
    photo: user.photo || null,

      emergencyMainName: user.emergency?.main?.name || '',
      // ⚠️ LETTURA TOLLERANTE DEL NUMERO D'EMERGENZA (RL-7a-ter) — `mobile`
      // OPPURE `phone`. La grafia unica in scrittura è `mobile` (RL-7a-bis:
      // il backend scrive sempre e solo quella), ma nei dati vivono ancora
      // documenti nati prima, col numero sotto `phone`. Leggendo il solo
      // `mobile` questa finestra li mostrava VUOTI, e siccome al salvataggio
      // rimanda comunque la chiave `mobile` — presente e vuota — il backend
      // la leggeva come cancellazione voluta (server.js —
      // `hasOwnProperty` distingue «non mandato» da «mandato vuoto») e il
      // numero da chiamare in emergenza, anche di un minore, spariva al primo
      // Save che non c'entrava nulla con l'emergenza.
      //
      // Il criterio è lo STESSO del tampone di RL-7a in HomeIncomplete.jsx
      // (`contattoDalDocumento`: `mobile || phone`): una sola
      // regola di lettura in tutto il frontend, non due.
      //
      // ⚠️ In SCRITTURA non cambia nulla: si rimanda `mobile` (vedi
      // handleSubmit). L'effetto combinato è che il modulo mostra il numero
      // qualunque sia la grafia d'origine e il salvataggio lo CONSOLIDA in
      // `mobile`, allineando il documento invece di svuotarlo.
      //
      // ⚠️ Un campo davvero vuoto — niente in `mobile` né in `phone` — resta
      // vuoto: qui non si inventa alcun numero, e un Save che manda
      // `mobile: ""` su un contatto che era già senza numero resta la
      // cancellazione legittima di un vuoto.
      emergencyMainMobile: user.emergency?.main?.mobile || user.emergency?.main?.phone || '',
      emergencyMainEmail: user.emergency?.main?.email || '',
      emergencySecondaryName: user.emergency?.secondary?.name || '',
      // Stesso trattamento del contatto principale: il secondario nasce dallo
      // stesso costruttore e porta quindi la stessa grafia storica.
      emergencySecondaryMobile: user.emergency?.secondary?.mobile || user.emergency?.secondary?.phone || '',
      emergencySecondaryEmail: user.emergency?.secondary?.email || '',

    // I CINQUE CAMPI DELLA SCHEDA (RL-7c-2). Il backend li accetta da tempo
    // dalla whitelist anagrafica (server.js) e la finestra
    // della persona (HomeIncomplete) li chiede già: qui mancavano soltanto, e
    // l'amministratore non poteva correggere ciò che leggeva nella scheda.
    //
    // ⚠️ Si inizializzano SEMPRE dal documento, mai da un vuoto di comodo:
    // questa finestra rispedisce nel PUT tutto ciò che tiene nel modulo, e un
    // campo nato vuoto qui cancellerebbe al primo Save il valore vero che sta
    // nei dati — lo stesso guasto del contatto d'emergenza chiuso con RL-7a-ter.
    // Il documento c'è per intero: la modale riceve `localUser` di
    // MemberProfileModal, cioè la risposta di GET /users/:id, non la riga
    // dell'elenco.
    languageAtHome: user.languageAtHome || '',
    school: user.school || '',

    // `disability` vive nel documento come mappa {has, details}; nel modulo sta
    // in due campi piatti, uno per input, e si ricompone nell'invio (come i sei
    // campi dell'emergenza). `has` passa dalla tendina a tre valori.
    disabilityHas: disabilitaDalDocumento(user.disability?.has),
    disabilityDetails: user.disability?.details || '',

    // `wwc` è {number, expiry, documentUrl}: di modificabile ci sono i primi
    // due, ed è tutto ciò che il modulo tiene. `documentUrl` NON entra qui e
    // non viene rispedito — non c'è rotta per caricarlo né per leggerlo, ed è
    // il backend a conservarlo quando la chiave non arriva (server.js).
    wwcNumber: user.wwc?.number || '',
    wwcExpiry: user.wwc?.expiry || '',
  });

  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // ------------------------------------------------------------------
  // FASE 3 — CHI DEVE AVERE UNA DATA DI NASCITA (e un genere).
  //
  // Il GENITORE non ne ha, per disegno: `/enrol-family` non gliela chiede
  // (server.js, il documento nasce con `dob: ""`) e il computo di
  // completezza del server NON gliela domanda — `CAMPI_ENROLLED_PARENT`
  // (server.js) non contiene né `dob` né `gender`, mentre
  // `CAMPI_ENROLLED_ANAGRAFICA` li contiene per tutti gli altri.
  //
  // ⚠️ IL METRO È QUELLO DEL SERVER, NON UNO NUOVO: `normalizeRole` sul solo
  // `role` di primo livello, esattamente come `calcolaEnrolled`
  // (server.js) e come `figuraDelDocumento` di HomeIncomplete.jsx,
  // dove lo stesso `figura !== "PARENT"` decide già l'asterisco su genere e
  // data. Qui non si inventa un predicato: se ne riusa la
  // nozione.
  //
  // ⚠️ Si guarda `form.role`, non `user.role`: se l'amministratore sta
  // portando un genitore a PLAYER, la data gli diventa obbligatoria SUBITO,
  // nella stessa schermata in cui cambia il ruolo, e non al Save successivo.
  const eGenitore = normalizeRole(form.role) === "PARENT";

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    setSuccess('');

    if (!form.firstName || !form.lastName) {
      setError("First Name and Last Name are required.");
      setSaving(false);
      return;
    }

    // FASE 3 — LA DATA, PER CHI LA DEVE AVERE, DEV'ESSERE LEGGIBILE.
    //
    // ⚠️ Non è una validazione di formato nuova: è la stessa lettura di
    // `dataDiNascitaLeggibile` (cioè `etaCompiuta`) portata QUI perché
    // l'attributo `required` dell'`<input type="date">` non basta da solo. Un
    // valore non-ISO che arrivi dal documento non entra nel campo — il
    // controllo del browser lo rende vuoto e `required` scatta — ma il valore
    // grezzo resta in `form.dob`, e dove il campo `date` degrada a testo
    // semplice `required` lo lascerebbe passare: partirebbe una richiesta che
    // il server rifiuta con un 400 «Invalid dob», cioè l'INTERA modifica
    // perduta per un campo che nessuno voleva toccare.
    if (!eGenitore && !dataDiNascitaLeggibile(form.dob)) {
      setError("Date of Birth is required, in the format YYYY-MM-DD.");
      setSaving(false);
      return;
    }

    // Il salvataggio sono DUE scritture distinte sul server — i dati
    // (PUT /users/:id) e i file (POST /upload, che scrive per conto proprio su
    // Firestore e su Storage) — e non c'e' modo di renderle una sola. Non
    // potendo evitare l'esito parziale, si sceglie DA CHE PARTE farlo cadere.
    //
    // ⚠️ ORDINE INVERTITO rispetto a prima (decisione dell'utente, 7/8/2026):
    // PRIMA i dati, POI i file. Se i dati falliscono non parte nulla; se
    // falliscono i file restano dati nuovi senza file — meno grave del vecchio
    // ordine, che lasciava foto e documenti d'identita' gia' sostituiti (anche
    // di minori) accanto a un'anagrafica vecchia.
    //
    // ⚠️ Tutto sta DENTRO il try, upload compreso: un rifiuto — oggi possibile
    // per davvero, da quando /upload chiede il login e la proprieta' del
    // documento — deve trovare qualcuno che lo raccolga, altrimenti esce da
    // questa funzione e nessuno rimette `saving` a false.
    try {
      // 1) I DATI.
      // I contatti d'emergenza vivono nel form come sei campi piatti, uno per
      // input; nel documento sono UNA mappa annidata `emergency`: qui si ricompone.
      // Le sei chiavi piatte non viaggiano nel corpo della richiesta.
      // Si spediscono SEMPRE entrambe le sezioni, complete: mai un invio parziale.
      //
      // Stesso trattamento per `disability` e `wwc` (RL-7c-2): quattro campi
      // piatti nel modulo, due mappe nel documento. Anche le loro chiavi piatte
      // restano fuori dal corpo della richiesta.
      const {
        emergencyMainName,
        emergencyMainMobile,
        emergencyMainEmail,
        emergencySecondaryName,
        emergencySecondaryMobile,
        emergencySecondaryEmail,
        disabilityHas,
        disabilityDetails,
        wwcNumber,
        wwcExpiry,
        // FASE 3 — `dob` e `gender` ESCONO DAL *REST* e rientrano più sotto
        // solo se hanno un valore che il server accetta. Vedi la nota nel
        // corpo della richiesta: è lì che si decide se spedirli.
        dob,
        gender,
        ...datiAnagrafici
      } = form;

      await api.put(`/users/${user.id}`, {
        ...datiAnagrafici,
        id: user.id,
        // FASE 3 — SI SPEDISCE SOLO CIÒ CHE È BUONO; il resto NON si tocca.
        //
        // Il server distingue «non mandato» da «mandato vuoto»
        // (`hasOwnProperty`, server.js): una chiave assente lascia intatto
        // il valore agli atti, ed è esattamente ciò che serve nei due casi in
        // cui questo modulo non ha un valore valido da proporre.
        //
        // ⚠️ `dob` — il GENITORE non ne ha, per disegno, e il suo documento
        // porta `dob: ""`. Mandandola comunque, il server rifiuta con 400
        // «Invalid dob» (server.js, che non accetta nemmeno lo
        // svuotamento) e l'amministratore perde l'INTERA modifica — nome,
        // recapiti, indirizzo — su una scheda che una data non deve averla.
        // Tacendo, il campo resta com'è e tutto il resto si salva. Per chi la
        // data la deve avere non si arriva mai qui con un valore illeggibile:
        // la guardia in testa a handleSubmit ha già fermato il salvataggio.
        //
        // ⚠️ `gender` — la stessa cortesia per il valore che questa finestra
        // NON sa tradurre (un «Other» agli atti): la tendina lo mostra come
        // «Select» e l'avviso chiede di scegliere, ma finché la scelta non
        // arriva il campo NON viene spedito, quindi non viene cancellato. Un
        // dato che non si sa leggere si segnala, non si distrugge.
        ...(dataDiNascitaLeggibile(dob) ? { dob: dob.trim() } : {}),
        ...(gender === "M" || gender === "F" ? { gender } : {}),
        // ⚠️ `has` è true, false o null e nient'altro: il server non tollera
        // grafie ("false" e 0 non sono un `no`, server.js) e da questo
        // booleano dipende `enrolled`. La tendina vuota vale null — «non
        // dichiarato» — che NON è un «no»: è la stessa conversione di
        // `corpoDaModulo` in HomeIncomplete.jsx.
        //
        // ⚠️ `details` parte SOLO col sì, e non è una svista: il server
        // distingue «non mandato» da «mandato vuoto» (hasOwnProperty,
        // server.js), quindi tacere conserva il testo già agli atti
        // invece di cancellarlo mentre l'input non è nemmeno a schermo.
        disability: {
          has:
            disabilityHas === "yes"
              ? true
              : disabilityHas === "no"
              ? false
              : null,
          ...(disabilityHas === "yes" ? { details: disabilityDetails.trim() } : {})
        },
        // Solo i due campi che il modulo mostra e tiene aggiornati dal
        // documento. `documentUrl` non viaggia: la chiave assente lascia al
        // server il valore già scritto (server.js), mentre mandarla
        // vuota lo cancellerebbe senza che nulla, in questa finestra, possa
        // rimetterlo.
        wwc: {
          number: wwcNumber.trim(),
          expiry: wwcExpiry.trim()
        },
        emergency: {
          main: {
            name: emergencyMainName,
            mobile: emergencyMainMobile,
            email: emergencyMainEmail
          },
          secondary: {
            name: emergencySecondaryName,
            mobile: emergencySecondaryMobile,
            email: emergencySecondaryEmail
          }
        }
      });

      // 2) I FILE, solo se l'utente ne ha scelto almeno uno ADESSO.
      //
      // ⚠️ Si guarda `instanceof File`, non la semplice verita' del campo:
      // `form` nasce dal documento del socio, e li'
      // `idDocument` e `otherDocument` sono gli oggetti {url, uploadedAt} del
      // fascicolo — sempre "veri". Con la sola verita' del campo, ogni Save di
      // chi ha gia' un documento agli atti spediva un upload PRIVO di file, e
      // un rifiuto di quella chiamata inutile (401 da sessione scaduta, 403,
      // 500) faceva leggere «i file non sono stati caricati» a chi non ne
      // aveva scelto nessuno.
      const fileScelti = [
        ["idDocument", form.idDocument],
        ["otherDocument", form.otherDocument],
        ["photo", form.photo]
      ].filter(([, valore]) => valore instanceof File);

      if (fileScelti.length > 0) {
        const fd = new FormData();

        for (const [campo, file] of fileScelti) {
          fd.append(campo, file);
        }

        // ✅ IMPORTANTE
        fd.append("userId", user.id);

        try {
          await api.postForm("/upload", fd);
        } catch (err) {
          console.error("Upload failed:", err);

          // Messaggio DISTINTO da quello dei dati: qui il profilo e' stato
          // salvato davvero, e dirlo evita che la persona rifaccia da capo
          // una modifica gia' andata a buon fine.
          setError(
            'Your details were saved, but the files could not be uploaded. Please try again.'
          );

          // La pagina dietro deve comunque sapere dei dati salvati, altrimenti
          // resterebbe ferma a prima di una scrittura riuscita. Si chiama
          // senza argomento perche' rilegga per conto suo — dove `onUpdate` e'
          // vuoto o assente non si aggiorna nulla (audit 10 §A.2).
          onSave && onSave();

          // La modale resta aperta, con l'errore in vista: i file si possono
          // ritentare. `saving` lo sblocca il finally.
          return;
        }
      }

      // 3) RILETTURA — con catch PROPRIO. E' solo una lettura: se fallisce, le
      // scritture sono comunque riuscite e l'esito resta un successo. Prima
      // condivideva il catch delle scritture, e un guasto di sola lettura
      // veniva raccontato come un salvataggio fallito.
      let updatedUser = null;

      try {
        updatedUser = await api.get(`/users/${user.id}`);
      } catch (err) {
        console.error("Profile re-read failed after save:", err);
      }

      setSuccess('Profile updated successfully!');

      // Con la rilettura fallita si chiama onSave SENZA argomento: il
      // chiamante non riceve un documento vecchio spacciato per nuovo. Che poi
      // qualcuno rilegga non e' garantito — dove `onUpdate` e' vuoto o assente
      // non si aggiorna nulla (audit 10 §A.2).
      onSave && (updatedUser ? onSave(updatedUser) : onSave());

      setTimeout(() => onClose(), 800);
    } catch (err) {
      // Qui ci si arriva quando falliscono i DATI — e allora l'upload non e'
      // nemmeno partito — oppure quando lancia qualcosa che sta fuori dai due
      // try interni.
      //
      // ⚠️ Il messaggio dice «not saved» perche' e' vero nei rifiuti decisi
      // dai controlli che PRECEDONO la scrittura — 401 di requireAuth (il piu'
      // frequente: sessione scaduta mentre si compilava), 403, 404 e 400 di
      // PUT /users/:id — che sono il caso comune. Non e' una garanzia: un 500
      // puo' nascere anche dalla scrittura stessa, e una risposta persa a
      // meta' lascerebbe un salvataggio riuscito raccontato come fallito. In
      // quei casi nessun messaggio sarebbe certo, e invitare a riprovare resta
      // la mossa giusta.
      console.error("Profile update failed:", err);
      // D-ADMIN2 (RD-157): il solo 403 del ruolo che vive nei contesti ha la
      // sua frase — riprovare non servirebbe. Ogni altro errore, il testo di
      // prima.
      setError(
        eRifiutoDelRuoloNeiContesti(err)
          ? MESSAGGIO_RUOLO_NEI_CONTESTI
          : 'Failed to update. Your details were not saved. Please try again.'
      );
    } finally {
      // In un finally, non in coda al try: cosi' lo stato si sblocca in OGNI
      // esito, compresi i return anticipati.
      setSaving(false);
    }
  };

  const [showCamera, setShowCamera] = useState(false);
  const webcamRef = useRef(null);

  // Le descrizioni di sezione aperte, per chiave (doc 07 §11.3, richiamato dal
  // §12.4). Piu' d'una puo' restare aperta: il §11.3 chiede che il secondo
  // tocco richiuda, non che l'apertura di una chiuda le altre.
  const [descrizioniAperte, setDescrizioniAperte] = useState({});

  const apriDescrizione = useCallback((chiave) => {
    setDescrizioniAperte((aperte) => ({
      ...aperte,
      [chiave]: !aperte[chiave]
    }));
  }, []);

  const capturePhoto = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    fetch(imageSrc)
      .then(res => res.blob())
      .then(blob => {
        const file = new File([blob], "selfie.jpg", { type: "image/jpeg" });
        setForm({ ...form, photo: file });
        setShowCamera(false);
      });
  };

  if (!isAdmin) return null;

  // ------------------------------------------------------------------
  // DERIVATI DI SOLA PRESENTAZIONE. Nessuno di questi tocca il modulo: non
  // entrano nel payload, non cambiano una validazione, non decidono un
  // accesso. Servono alla sola testata e all'accensione della sezione WWC.
  // ------------------------------------------------------------------
  const nomeCompleto = [user.firstName, user.lastName]
    .filter(Boolean)
    .join(" ")
    .trim();

  const statoSoggetto = normalizeRole(user.status) || "ACTIVE";

  // ⚠️ LA SEZIONE WWC COMPARE SOLO SULLA SCHEDA DI UN COACH (§12.3), e la
  // domanda è «IL TESSERATO è un coach?», non «chi guarda lo è»: si passa da
  // `hasRole` sul documento mostrato, esattamente come View Profile, che
  // riconosce anche i MANAGER/TD/MANAGERTD del modello vecchio (vocabolario
  // di access.js). Prima questi due campi si mostravano a chiunque.
  const soggettoECoach = hasRole(user, "COACH");

  // D4 — L'ETÀ accanto alla data di nascita, in SOLA LETTURA: non è un campo,
  // non viaggia nel payload, e si ricalcola mentre si digita perché legge
  // `form.dob` e non il documento.
  // ⚠️ `etaCompiuta` torna null quando la data non è leggibile — forma non
  // ISO, giorno inesistente, campo vuoto — e allora l'aiuto semplicemente NON
  // si mostra: mai un «NaN» né un «Invalid Date» accanto a un campo che si sta
  // ancora compilando. La VALIDAZIONE della data non si tocca: è materia della
  // fase funzionale.
  const eta = etaCompiuta(form.dob, oggiAPerth());

  // FASE 3, guardia dell'aiuto D4 — L'ETÀ SI MOSTRA SOLO SE PLAUSIBILE.
  //
  // Una data può essere ISO e vera a calendario e restare assurda: in beta c'è
  // un `1018-02-02`, che il server accetta e che qui produrrebbe un «age 1008»
  // accanto al campo. È lo stesso principio del «niente NaN» di D4 — un aiuto
  // che non aiuta non si mostra — e vale per entrambi i versi: nessuno ha
  // meno di zero anni, e oltre i 120 non è più un'anagrafica, è un refuso.
  //
  // ⚠️ È SOLO L'AIUTO A SCHERMO. Non blocca, non converte, non entra nel
  // payload: la data assurda resta salvabile esattamente come prima, perché
  // bonificare i dati è un altro mestiere. La guardia sta tutta in questa riga
  // e si toglie togliendola.
  const etaPlausibile = eta !== null && eta >= 0 && eta <= 120;

  // FASE 3 — I DUE AVVISI, entrambi di sola presentazione.
  //
  // ⚠️ Guardano `form`, non `user`: spariscono da soli appena
  // l'amministratore mette a posto il campo, senza aspettare il Save. Il testo
  // dell'avviso della data mostra il valore GREZZO, che è precisamente ciò che
  // il campo `date` non riesce a mostrare (resta vuoto, e prima della fase 3
  // restava vuoto in silenzio: nessuno poteva sapere che cosa ci fosse).
  const dobDaCorreggere =
    String(form.dob || "").trim() !== "" && !dataDiNascitaLeggibile(form.dob);

  // Il genere non traducibile: `form.gender` è «» (la tendina dice «Select»),
  // ma agli atti c'è dell'altro. Si mostra il valore grezzo del DOCUMENTO —
  // l'unico posto dove sia rimasto — e l'avviso si spegne appena si sceglie.
  const genereGrezzo = String(user.gender || "").trim();
  const genereDaScegliere =
    genereGrezzo !== "" && genereDalDocumento(genereGrezzo) === "" && form.gender === "";

  const propsSezione = { aperte: descrizioniAperte, onApri: apriDescrizione };

  return (
    <>
      {/* ============================================================
          TESTATA (SPEC §2, doc 07 §12.6): foto, nome, pastiglie.
          È CONTESTO IN LETTURA: il nome e la foto si modificano nelle
          sezioni sotto, non da qui.
          ============================================================ */}
      <header className="qpsc-em-head">
        {/* La foto arriva dal backend con fetch autenticata: lo Storage è
            chiuso in lettura (storage.rules). Vedi AuthAvatar. */}
        <AuthAvatar
          userId={user.id}
          photoKey={user.photoUrl || ""}
          name={nomeCompleto}
          alt={nomeCompleto || "Member"}
          className="qpsc-em-head__photo"
          fallbackSrc={avatarPlaceholder}
        />

        <h1 className="qpsc-page-title">{nomeCompleto || "Member"}</h1>

        <div className="qpsc-em-marks">
          <span className={`qpsc-pill qpsc-em-pill--${statoSoggetto.toLowerCase()}`}>
            {statoSoggetto}
          </span>

          {/* ⚠️ `isMinor` lo CALCOLA il server dalla data di nascita e lo
              scrive sul documento: qui non si deduce nulla dal `dob`, si legge
              il campo. Un documento vecchio che non lo porta semplicemente non
              mostra l'etichetta. */}
          {user.isMinor === true && (
            <span className="qpsc-pill qpsc-em-pill--minor">Minor</span>
          )}

          {/* §2: la pastiglia TACE se la categoria non è nota.
              LA CATEGORIA È ANAGRAFICA (D-ADMIN2, RD-157): genere + età
              compiuta al 31/12 dell'anno operativo, dalla sede unica
              `categoriaAnagrafica` — come View Profile (MemberProfileModal),
              che non legge più `/teams`. Prima qui si leggeva
              `user.category`, un campo che nessuna rotta scrive su una
              persona: sui soci nuovi la pastiglia non c'era mai. Si calcola
              sul documento SALVATO (`user`), come il resto dell'intestazione,
              non sul modulo in corso di modifica. Anno operativo `null`
              (stagione non letta) → `categoriaAnagrafica` ripiega su oggi. */}
          <PastigliaCategoriaSeNota
            category={categoriaAnagrafica(user, annoOperativo)}
          />
        </div>
      </header>

      <form className="qpsc-em-form" onSubmit={handleSubmit}>
        {/* §1.3: l'errore in rosso LEGGIBILE (a 14px il Rosso QPSC non
            raggiunge AA), la conferma in verde di stato. */}
        {error && (
          <p className="qpsc-em-alert qpsc-em-alert--error" role="alert">{error}</p>
        )}
        {success && (
          <p className="qpsc-em-alert qpsc-em-alert--ok" role="status">{success}</p>
        )}

        {/* ============================================================
            1a — CORE (SPEC §3): Photo → Identity → Contacts → Address →
            Emergency Contacts. L'ordine CORREGGE l'anomalia della vecchia
            modale, dove i file stavano in mezzo all'anagrafica e la foto
            in fondo.
            ============================================================ */}
        <Sezione chiave="core" titolo="Core" {...propsSezione}>
          <div className="qpsc-em-fields">

            <p className="qpsc-em-subhead">Photo</p>

            <Campo etichetta="Profile Photo" htmlFor="em-photo">
              <input
                id="em-photo"
                className="qpsc-em-file"
                type="file"
                name="photo"
                accept="image/*"
                onChange={(e) => setForm({ ...form, photo: e.target.files[0] })}
              />
            </Campo>

            {/* §5.3 FANTASMA: è un'azione di servizio, non l'azione della
                pagina — quella è il Save, ed è una sola. */}
            <button
              type="button"
              className="qpsc-ghost-btn"
              onClick={() => setShowCamera(true)}
            >
              Take a Selfie
            </button>

            {showCamera && (
              <div className="qpsc-em-selfie">
                <Webcam
                  audio={false}
                  ref={webcamRef}
                  screenshotFormat="image/jpeg"
                  videoConstraints={{ facingMode: "user" }}
                />
                <div className="qpsc-em-selfie__actions">
                  <button type="button" className="qpsc-tool-btn" onClick={capturePhoto}>
                    Capture
                  </button>
                  <button
                    type="button"
                    className="qpsc-ghost-btn"
                    onClick={() => setShowCamera(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}

            <p className="qpsc-em-subhead">Identity</p>

            <Campo etichetta="FFA Number" htmlFor="em-ffa">
              <input
                id="em-ffa"
                className="qpsc-em-input"
                name="ffaNumber"
                value={form.ffaNumber}
                onChange={handleChange}
              />
            </Campo>

            <Campo etichetta="First Name*" htmlFor="em-first">
              <input
                id="em-first"
                className="qpsc-em-input"
                name="firstName"
                value={form.firstName}
                onChange={handleChange}
                required
              />
            </Campo>

            <Campo etichetta="Middle Name" htmlFor="em-middle">
              <input
                id="em-middle"
                className="qpsc-em-input"
                name="middleName"
                value={form.middleName}
                onChange={handleChange}
              />
            </Campo>

            <Campo etichetta="Last Name*" htmlFor="em-last">
              <input
                id="em-last"
                className="qpsc-em-input"
                name="lastName"
                value={form.lastName}
                onChange={handleChange}
                required
              />
            </Campo>

            {/* D4: l'età sta NELL'ETICHETTA, in sola lettura.
                FASE 3: l'asterisco e l'obbligo cadono sulla scheda di un
                GENITORE, che una data di nascita non ce l'ha per disegno; e
                l'età si mostra solo se plausibile (`etaPlausibile`). */}
            <Campo
              etichetta={
                <>
                  Date of Birth{eGenitore ? "" : "*"}
                  {etaPlausibile && (
                    <span className="qpsc-em-age"> — age {eta}</span>
                  )}
                </>
              }
              htmlFor="em-dob"
            >
              <input
                id="em-dob"
                className="qpsc-em-input"
                type="date"
                name="dob"
                value={form.dob}
                onChange={handleChange}
                required={!eGenitore}
              />

              {/* IL PARACADUTE (fase 3). Un `<input type="date">` a cui si dia
                  qualcosa che non sia `YYYY-MM-DD` mostra il CAMPO VUOTO e non
                  dice nulla: chi amministra vede un buco al posto di un dato
                  che invece c'è, e non ha modo di sapere che cosa ci fosse.
                  Qui il valore grezzo si legge, e si chiede di reinserirlo.
                  ⚠️ NESSUNA CONVERSIONE AUTOMATICA: «05/06/2011» è ambigua e
                  la data di nascita di un minore non si indovina. */}
              {dobDaCorreggere && (
                <p className="qpsc-em-hint qpsc-em-hint--warn" role="alert">
                  The stored date of birth ("{form.dob}") isn't in a readable
                  format (YYYY-MM-DD). Please re-enter it.
                </p>
              )}
            </Campo>

            {/* ⚠️ QUI C'ERA «City of Birth», tolta con la decisione D1: vedi
                la nota sullo stato del modulo, più sopra. Il valore agli atti
                non viene toccato. */}

            <Campo etichetta="Country of Birth" htmlFor="em-country">
              <input
                id="em-country"
                className="qpsc-em-input"
                name="countryOfBirth"
                value={form.countryOfBirth}
                onChange={handleChange}
              />
            </Campo>

            <Campo etichetta="Nationality" htmlFor="em-nationality">
              <input
                id="em-nationality"
                className="qpsc-em-input"
                name="nationality"
                value={form.nationality}
                onChange={handleChange}
              />
            </Campo>

            {/* FASE 3 — LE OPZIONI VENGONO DA `GENERI`: valore «M»/«F»,
                etichetta per esteso. Prima i valori erano le parole intere e
                c'era una terza voce, «Other», che NESSUNA sorgente scrive:
                salvarla significava mettere agli atti un valore che le rotte
                nuove del server rifiutano. L'asterisco e l'obbligo cadono per
                il GENITORE, a cui il computo del server non chiede il genere
                (CAMPI_ENROLLED_PARENT, server.js). */}
            <Campo etichetta={`Gender${eGenitore ? "" : "*"}`} htmlFor="em-gender">
              <select
                id="em-gender"
                className="qpsc-em-input"
                name="gender"
                value={form.gender}
                onChange={handleChange}
                required={!eGenitore}
              >
                <option value="">Select</option>
                {GENERI.map((g) => (
                  <option key={g.valore} value={g.valore}>
                    {g.etichetta}
                  </option>
                ))}
              </select>

              {/* LA SALVAGUARDIA. Il valore agli atti non è né Male né Female
                  (un «Other», o altro ancora): la tendina non può mostrarlo e
                  dice «Select». Senza questo avviso il campo sembrerebbe
                  semplicemente vuoto, e il primo Save lo sostituirebbe con una
                  scelta fatta al buio. Finché nessuno sceglie, il campo non
                  viene spedito e il dato resta dov'è (vedi handleSubmit). */}
              {genereDaScegliere && (
                <p className="qpsc-em-hint qpsc-em-hint--warn" role="alert">
                  Stored value ("{genereGrezzo}") isn't Male or Female — please
                  choose one.
                </p>
              )}
            </Campo>

            {/* ⚠️ QUI C'ERA LA SPUNTA «Registering a Minor», tolta con RL-7c-2
                e non spostata altrove. `isMinor` è un CALCOLO sulla data di
                nascita (isMinorDaDob) e non è scrivibile da nessuno: la spunta
                veniva scartata in silenzio e il Save annunciava un cambiamento
                mai avvenuto. Per rendere minorenne una persona si corregge
                `dob`, qui sopra. */}

            <p className="qpsc-em-subhead">Contacts</p>

            <Campo
              etichetta="Email"
              htmlFor="em-email"
              aiuto="Email is not editable here."
            >
              <input
                id="em-email"
                className="qpsc-em-input"
                type="email"
                name="email"
                value={form.email}
                disabled
              />
            </Campo>

            <Campo etichetta="Phone" htmlFor="em-phone">
              <input
                id="em-phone"
                className="qpsc-em-input"
                name="phone"
                value={form.phone}
                onChange={handleChange}
              />
            </Campo>

            <p className="qpsc-em-subhead">Address</p>

            <Campo etichetta="Street" htmlFor="em-street">
              <input
                id="em-street"
                className="qpsc-em-input"
                name="street"
                value={form.street}
                onChange={handleChange}
              />
            </Campo>

            <Campo etichetta="Suburb" htmlFor="em-suburb">
              <input
                id="em-suburb"
                className="qpsc-em-input"
                name="suburb"
                value={form.suburb}
                onChange={handleChange}
              />
            </Campo>

            {/* Due campi corti in linea dove c'è spazio; sotto i 480px si
                incolonnano da soli (§4, mobile first). */}
            <div className="qpsc-em-row">
              <Campo etichetta="State" htmlFor="em-state">
                <select
                  id="em-state"
                  className="qpsc-em-input"
                  name="state"
                  value={form.state}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  {stateOptions.map(s => <option key={s}>{s}</option>)}
                </select>
              </Campo>

              <Campo etichetta="Postcode" htmlFor="em-postcode">
                <input
                  id="em-postcode"
                  className="qpsc-em-input"
                  name="postcode"
                  value={form.postcode}
                  onChange={handleChange}
                />
              </Campo>
            </div>

            <p className="qpsc-em-subhead">Emergency Contacts</p>

            {/* Sotto-intestazioni MAIUSCOLE: deroga §3.2 concessa dal §12.6 e
                limitata a questa pagina. Il maiuscolo lo fa il foglio, non il
                testo: chi legge con un lettore di schermo sente «Primary». */}
            <p className="qpsc-em-subhead">Primary</p>

            <Campo etichetta="Name" htmlFor="em-em1-name">
              <input
                id="em-em1-name"
                className="qpsc-em-input"
                name="emergencyMainName"
                value={form.emergencyMainName}
                onChange={handleChange}
              />
            </Campo>

            <Campo etichetta="Mobile" htmlFor="em-em1-mobile">
              <input
                id="em-em1-mobile"
                className="qpsc-em-input"
                name="emergencyMainMobile"
                value={form.emergencyMainMobile}
                onChange={handleChange}
              />
            </Campo>

            <Campo etichetta="Email" htmlFor="em-em1-email">
              <input
                id="em-em1-email"
                className="qpsc-em-input"
                type="email"
                name="emergencyMainEmail"
                value={form.emergencyMainEmail}
                onChange={handleChange}
              />
            </Campo>

            <p className="qpsc-em-subhead">Secondary</p>

            <Campo etichetta="Name" htmlFor="em-em2-name">
              <input
                id="em-em2-name"
                className="qpsc-em-input"
                name="emergencySecondaryName"
                value={form.emergencySecondaryName}
                onChange={handleChange}
              />
            </Campo>

            <Campo etichetta="Mobile" htmlFor="em-em2-mobile">
              <input
                id="em-em2-mobile"
                className="qpsc-em-input"
                name="emergencySecondaryMobile"
                value={form.emergencySecondaryMobile}
                onChange={handleChange}
              />
            </Campo>

            <Campo etichetta="Email" htmlFor="em-em2-email">
              <input
                id="em-em2-email"
                className="qpsc-em-input"
                type="email"
                name="emergencySecondaryEmail"
                value={form.emergencySecondaryEmail}
                onChange={handleChange}
              />
            </Campo>
          </div>
        </Sezione>

        {/* ============================================================
            1b — IDENTITY DOCUMENTS (SPEC §3). I file salgono con la
            seconda chiamata (POST /upload): il modulo non cambia.
            ============================================================ */}
        <Sezione chiave="documents" titolo="Identity Documents" {...propsSezione}>
          <div className="qpsc-em-fields">
            <Campo etichetta="ID / Driver's License" htmlFor="em-id-doc">
              <input
                id="em-id-doc"
                className="qpsc-em-file"
                type="file"
                name="idDocument"
                accept=".pdf,.jpg,.jpeg,.png"
                onChange={(e) => setForm({ ...form, idDocument: e.target.files[0] })}
              />
            </Campo>

            <Campo etichetta="Other Document" htmlFor="em-other-doc">
              <input
                id="em-other-doc"
                className="qpsc-em-file"
                type="file"
                name="otherDocument"
                accept=".pdf,.jpg,.jpeg,.png"
                onChange={(e) => setForm({ ...form, otherDocument: e.target.files[0] })}
              />
            </Campo>
          </div>
        </Sezione>

        {/* ============================================================
            2 — INCLUSION & WELLBEING (SPEC §3): salute, lingua, scuola.
            ============================================================ */}
        <Sezione chiave="wellbeing" titolo="Inclusion & Wellbeing" {...propsSezione}>
          <div className="qpsc-em-fields">
            {/* ⚠️ TRE risposte, non due: sì, no e «not declared» — che è il
                modo in cui nasce un documento e NON è un «no». */}
            <Campo
              etichetta="Disability the club should know about"
              htmlFor="em-disability"
            >
              <select
                id="em-disability"
                className="qpsc-em-input"
                name="disabilityHas"
                value={form.disabilityHas}
                onChange={handleChange}
              >
                <option value="">Not declared</option>
                <option value="no">No</option>
                <option value="yes">Yes</option>
              </select>
            </Campo>

            {/* I dettagli hanno senso solo col sì, e solo allora viaggiano. */}
            {form.disabilityHas === "yes" && (
              <Campo etichetta="Disability details" htmlFor="em-disability-details">
                <input
                  id="em-disability-details"
                  className="qpsc-em-input"
                  name="disabilityDetails"
                  value={form.disabilityDetails}
                  onChange={handleChange}
                />
              </Campo>
            )}

            {/* Scuola e lingua di casa: il server li chiede al solo minore per
                considerare consegnata la scheda, ma qui si mostrano a
                chiunque — l'amministratore corregge il documento che ha
                davanti, e su un adulto restano semplicemente vuoti. */}
            <Campo etichetta="Language Spoken at Home" htmlFor="em-language">
              <input
                id="em-language"
                className="qpsc-em-input"
                name="languageAtHome"
                value={form.languageAtHome}
                onChange={handleChange}
              />
            </Campo>

            <Campo etichetta="School" htmlFor="em-school">
              <input
                id="em-school"
                className="qpsc-em-input"
                name="school"
                value={form.school}
                onChange={handleChange}
              />
            </Campo>
          </div>
        </Sezione>

        {/* ============================================================
            3 — ROLE (SPEC §3/§4): il ruolo primario. Comportamento della
            tendina invariato, comprese le opzioni disabilitate.
            ============================================================ */}
        <Sezione chiave="primaryRole" titolo="Role" {...propsSezione}>
          <div className="qpsc-em-fields">
            <Campo etichetta="Role*" htmlFor="em-role">
              {/* ⚠️ `value` passa da `normalizeRole`, cioè SOLA GRAFIA: senza,
                  un documento in grafia storica ("Player") non aggancerebbe
                  alcuna opzione e la tendina mostrerebbe «Select», come se la
                  persona non avesse ruolo. NON si usa `canonicalRole` qui:
                  siamo a un passo da una scrittura, e tradurre mostrerebbe
                  «Coach» selezionato su un documento che nei dati dice
                  «Manager».

                  ⚠️ Lo STATO non viene toccato: `form.role` conserva la grafia
                  originale finché l'amministratore non sceglie davvero
                  un'altra voce, e una riscrittura identica il backend la
                  lascia passare senza controlli. */}
              <select
                id="em-role"
                className="qpsc-em-input"
                name="role"
                value={normalizeRole(form.role)}
                onChange={handleChange}
                disabled={!isAdmin}
              >
                <option value="">Select</option>

                {/* Il ruolo attuale, quando non è più assegnabile (i documenti
                    storici: "Manager", "Fan/Supporter", "Child"…). Si mostra
                    DISABILITATO invece di sparire: se sparisse, la tendina
                    direbbe «Select» e chi amministra, credendo il campo vuoto,
                    sceglierebbe una voce «per riempirlo» — cioè un cambio di
                    ruolo deliberato che non voleva fare. */}
                {form.role &&
                  !ruoliAssegnabili.some(r => r.value === normalizeRole(form.role)) && (
                    <option value={normalizeRole(form.role)} disabled>
                      {ROLE_LABELS[normalizeRole(form.role)] || form.role} (not assignable)
                    </option>
                )}

                {ruoliAssegnabili.map(({ value, label }) => (
                  <option key={value} value={value}>{label}</option>
                ))}
              </select>
            </Campo>

            {/* ⚠️ QUI C'ERA IL CAMPO «Team», tolto con RL-7c-2. `team` è fuori
                whitelist DI PROPOSITO: la sede unica dell'assegnazione squadre
                è Team Assignment, con rotte proprie. L'input era scrivibile,
                il Save rispondeva «Profile updated successfully» e nei dati
                non cambiava nulla. */}
          </div>
        </Sezione>

        {/* ============================================================
            4 — WORKING WITH CHILDREN CHECK (SPEC §3, §12.3)
            SOLO sulla scheda di un COACH. Il FILE non c'è, e non è una
            dimenticanza: non esiste rotta per caricarlo né per rileggerlo,
            e il `documentUrl` agli atti resta intatto perché il modulo non
            lo tiene e non lo rispedisce.
            ============================================================ */}
        {soggettoECoach && (
          <Sezione
            chiave="wwc"
            titolo="Working with Children Check"
            {...propsSezione}
          >
            <div className="qpsc-em-fields">
              <Campo etichetta="WWC Number" htmlFor="em-wwc-number">
                <input
                  id="em-wwc-number"
                  className="qpsc-em-input"
                  name="wwcNumber"
                  value={form.wwcNumber}
                  onChange={handleChange}
                />
              </Campo>

              <Campo etichetta="WWC Expiry" htmlFor="em-wwc-expiry">
                <input
                  id="em-wwc-expiry"
                  className="qpsc-em-input"
                  type="date"
                  name="wwcExpiry"
                  value={form.wwcExpiry}
                  onChange={handleChange}
                />
              </Campo>
            </div>
          </Sezione>
        )}

        {/* ============================================================
            IL COMANDO — uno solo (§12.5).
            §5.1: pulsante ORO a piena colonna, la classe CONDIVISA di
            AdminTools.css, non una copia locale.
            ⚠️ NIENTE «Cancel»: l'annullamento è il «Back» della banda
            (§7.2). Sparisce con esso il vecchio difetto del Cancel unico
            bloccato durante il salvataggio — il Back è sempre nel telaio.
            ============================================================ */}
        <div className="qpsc-em-save">
          <button
            type="submit"
            className="qpsc-tool-btn qpsc-tool-btn--wide"
            disabled={saving}
          >
            {saving ? 'Saving...' : 'Save Changes'}
          </button>
        </div>
      </form>
    </>
  );
}
